import { Icon } from '@chakra-ui/react';

export default function SFRecordCircleIcon(props) {
  return (
    <Icon
      width={36}
      height={36}
      viewBox='0 0 36 36'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M18 30.4922C11.4727 30.4922 6.04688 25.0664 6.04688 18.5391C6.04688 12 11.4609 6.58594 17.9883 6.58594C24.5273 6.58594 29.9531 12 29.9531 18.5391C29.9531 25.0664 24.5391 30.4922 18 30.4922ZM18 28.5C23.5312 28.5 27.9609 24.0703 27.9609 18.5391C27.9609 13.0078 23.5195 8.57812 17.9883 8.57812C12.457 8.57812 8.05078 13.0078 8.05078 18.5391C8.05078 24.0703 12.4688 28.5 18 28.5ZM18.0117 23.1211C15.4688 23.1211 13.4062 21.0586 13.4062 18.5156C13.4062 15.9844 15.4688 13.9336 18.0117 13.9336C20.543 13.9336 22.6055 15.9844 22.6055 18.5156C22.6055 21.0586 20.543 23.1211 18.0117 23.1211Z'
        fill='#1345BE'
      />
    </Icon>
  );
}
